import React from "react";
import { useDrag } from "react-dnd";
import { makeStyles } from "@material-ui/core/styles";

const ItemType = "marker";

const useStyles = makeStyles((theme) => ({
  draggableContainer: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "30px",
    height: "50px",
  },
  draggableCircle: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    backgroundColor: theme.palette.background.default,
    borderWidth: "5px",
    borderStyle: "solid",
    borderColor: theme.palette.secondary.main,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "500",
  },
  draggableCircleTriangle: {
    width: 0,
    height: 0,
    borderLeftWidth: "5px",
    borderLeftStyle: "solid",
    borderLeftColor: "transparent",
    borderRightWidth: "5px",
    borderRightStyle: "solid",
    borderRightColor: "transparent",
    borderTopWidth: "10px",
    borderTopStyle: "solid",
    borderTopColor: theme.palette.secondary.main,
    marginTop: "-2px",
  },
}));

const DraggableMarker = ({ id, position, index }) => {
  const classes = useStyles();
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemType,
      item: { id, type: ItemType, x: position.x, y: position.y },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [id, position]
  );

  return (
    <div
      ref={drag}
      className={classes.draggableContainer}
      style={{
        top: position.y - 40,
        left: position.x - 15,
        opacity: isDragging ? 0.5 : 1,
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <div className={classes.draggableCircle}>{index + 1}</div>
      <div className={classes.draggableCircleTriangle} />
    </div>
  );
};

export default DraggableMarker;
